import { createApp } from "vue";
import App from "./App.vue";
import { FontAwesomeIcon } from './assets/js/fontawesome'
import { createPinia } from "pinia";
import router from "./router";

import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";

import ArgonDashboard from "./argon-dashboard";
import { applySidebarColor } from "@/assets/js/helpers/theme";
import ArgonPagination from "@/modules/shared/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/modules/shared/components/ArgonPaginationItem.vue";
import Paginator from "@/modules/shared/components/Paginator.vue";
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css'

import { useUiStore } from "@/store/uiStore";
import { llamarToast } from "@/assets/js/helpers/alerts"; 
window.llamarToast = llamarToast;


const app = createApp(App);

// Inicializar Pinia
const pinia = createPinia();
app.use(pinia);
//select-2
app.component("v-select", vSelect);
// Otros plugins
app.use(router);
app.use(ArgonDashboard);



// Componentes globales
app.component("ArgonPagination", ArgonPagination);
app.component("ArgonPaginationItem", ArgonPaginationItem);
app.component("Paginator", Paginator);
app.component('font-awesome-icon', FontAwesomeIcon)

// Montar la app primero
app.mount("#app");

// ✅ Restaurar configuración desde localStorage
const ui = useUiStore();
ui.restoreFromLocalStorage();
applySidebarColor(ui.sidebarColor);
